import SvgWrapper from './SvgWrapper';
import { AllergnIconProps } from './types';

const NutsIcon = ({
  innerColor = '#fefefe',
  outerColor = '#cf4d51',
  ...props
}: AllergnIconProps) => {
  const style = {
    fill: innerColor,
  };

  return (
    <SvgWrapper {...props}>
      <g
        id="Grupo_141"
        data-name="Grupo 141"
        transform="translate(-207.938 -1650.062)"
      >
        <g
          id="Rectángulo_20"
          data-name="Rectángulo 20"
          transform="translate(207.938 1650.062)"
          fill="#fff"
          stroke="#000"
          stroke-width="1"
        >
          <rect width="27" height="27" rx="2" stroke="none" />
          <rect x="0.5" y="0.5" width="26" height="26" rx="1.5" fill="none" />
        </g>
        <g
          id="Grupo_140"
          data-name="Grupo 140"
          transform="translate(-0.596 0.092)"
        >
          <path
            id="Trazado_9371"
            data-name="Trazado 9371"
            d="M5142.374,3244.607c.645-.362,1.392.2,1.756.411.54.316.517.324.805.869-.475-.126-.395-.463-1.2-.673a5.188,5.188,0,0,1-1.167-.311C5142.19,3244.622,5142.56,3244.961,5142.374,3244.607Zm-.788-1.478Zm0,0c-.378-.253-.418-.476-.882-.694a5.023,5.023,0,0,0-1.385-.291,2.667,2.667,0,0,1,.4,1.084c-.5-.368-.072-.7-1.913-1.929-.3-.2-.515-.3-.55-.731a1.472,1.472,0,0,1,1.478.985,4.287,4.287,0,0,1,1.874.293A1.488,1.488,0,0,1,5141.585,3243.129Zm-7.586-2.463c0,.9-.153.526,1.436,1.717l10.88,8.135c.506-1.056-.2-.594-.2-1.478,0-.578.246-.074-.043-.639-.615-1.2-1.744-.115-1.829-1.134.609-.142,1.971-.056,1.971,1.084.911-.244.229-1.725-.264-2.1-.515-.391-.491.087-.821-.362.856-.2.338-.054.985,0a2.561,2.561,0,0,0-.761-2c-.915-.946-.566-.564-2-.564v-.394c.38-.1.254-.4,1.083,0,0-.795.1-.915-1.2-1.755-1.151-.743-1.03-.412-2.444-.412a6.473,6.473,0,0,0-2.957-.985,3.2,3.2,0,0,0-1.893.964C5134.994,3241.607,5135.278,3240.695,5134,3240.666Z"
            transform="translate(-4917.541 -1582.477)"
            fill="none"
            stroke="#000"
            stroke-miterlimit="2.613"
            stroke-width="0.7"
            fill-rule="evenodd"
          />
          <path
            id="Trazado_9372"
            data-name="Trazado 9372"
            d="M5068.544,3553.418c.45.12.545.381,1.177.5.5.093,1.091.077,1.582.192v.3c-.3.07-.458.2-.751.157A3.23,3.23,0,0,1,5068.544,3553.418Zm-2.364-1.083c.514.042.439.194,1,.018,1.12-.351.476-.152,1.308.047a.864.864,0,0,0,.506,0c.433-.092.5-.25,1.028-.262-.012.563-.049.322-.3.689a5.89,5.89,0,0,1-.891-.093c-.508-.061-.417-.107-.783-.3-.3.446-.359.415-.915.333C5066.523,3552.676,5066.462,3552.757,5066.18,3552.335Zm0,0Zm-2.856-3.35c.628.421.557.532,1.166.706.514.146,1.111.088,1.4.477-.61.833-2.227-.533-2.41-.842A1.984,1.984,0,0,1,5063.323,3548.985Zm-1.3-3.273a.927.927,0,0,0,.711.515c-.094.354-.266.383-.361.828-.11.512.066.621.066,1.142,0,.811-.568,2.562,2.069,2.562a1.09,1.09,0,0,1-1.182.1c.184,2.221.416,2.833,2.763,2.458a.926.926,0,0,1,.784.1c-.441.658-.773.512-1.281.394a2.886,2.886,0,0,0,1.184.886c1.708.758,1.385.647,2.914.444.946-.125,1.094.834,2.414.059.428-.251.425-.388.706-.582.575-.4,1.156.493,1.748-.314l-9.007-6.755a36.228,36.228,0,0,0-3.111-2.209l-.416.372Z"
            transform="translate(-4847.076 -1885.87)"
            fill="none"
            stroke="#000"
            stroke-miterlimit="2.613"
            stroke-width="0.7"
            fill-rule="evenodd"
          />
        </g>
      </g>
    </SvgWrapper>
  );
};

export default NutsIcon;
